import { Button, Modal as ModalContainer } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import UploadFileComponent from '../../Acquisitions/UploadAcquisitionsFileComponent';
import { useState } from 'react';
import { useAuth } from 'oidc-react';
import UploadInvoicingFileComponent from '../UploadInvoicingFileComponent';
import Loader from '../../Shared/Loader';


interface ModalProps {
    title: string;
    isShowing: boolean;
    hide: () => void;
    buttonSaveTitle?: string;
    buttonCloseModalTitle?: string;
    action?: any;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}


interface ModalUploadProps {
    file: any;
}

export default function UploadXMLInvoicingModal({ title, isShowing, hide, buttonSaveTitle = 'Salvar', buttonCloseModalTitle = 'Fechar', action, setLoading }: ModalProps) {
    let userData = useAuth()?.userData;

    const { register, handleSubmit, formState: { errors } } = useForm<ModalUploadProps>();

    return (
        isShowing
            ?
            (
                <ModalContainer show={isShowing} onHide={hide}>
                    <form className='form' onSubmit={handleSubmit(action)}>
                        <ModalContainer.Header closeButton>
                            <ModalContainer.Title>{title}</ModalContainer.Title>
                        </ModalContainer.Header>
                        <ModalContainer.Body>
                            <UploadInvoicingFileComponent
                                toggleLoading={setLoading}
                                userEmail={userData?.profile.email ?? ''}
                                hide={hide}
                            />
                        </ModalContainer.Body>
                    </form>
                </ModalContainer >
            )
            :
            null
    )
}